import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-ln-cone-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-cone-svg-icon.component.html',
  styleUrl: './ln-cone-svg-icon.component.css',
})
export class LnConeSvgIconComponent {
  @Input() class = 'w-14 h-14 sm:w-28 sm:h-28';
}
